<script lang="ts">
	import RecipeCard from '$lib/components/RecipeCard.svelte';
	import type { PageData } from './$types';

	export let data: PageData;

	$: recipe = data.recipe;
</script>

<section>
	<h1 class="text-center text-xl font-medium text-surface-content/70">{recipe?.title} Recipe</h1>
	{#if recipe}
		<RecipeCard {recipe} />
	{/if}
</section>
